var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectTimePeriod"},_vm._l((_vm.timePeriod),function(item,index){return _c('div',{key:index,staticClass:"timeItem",style:({'color': item.check ? _vm.color.color : '', 'backgroundColor': item.check ? _vm.color.bagColor : ''}),on:{"click":function($event){return _vm.selectTime(item, index)}}},[_vm._v(_vm._s(item.value))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }